import PublicPageLayout from "../../components/publicSite/PublicPageLayout";

const lakes = [
  { name: "Parco della Sciola", image: "/images/lago-principale.jpeg", description: "Pesca no kill e relax", address: "Loc. Sassuolo, SNC, 06023 Gualdo Tadino (PG)", map: "https://maps.app.goo.gl/pbyejUFCvHQUtkFe7" },
  { name: "Parco della Sciola 2", image: "/images/lago-2.jpeg", description: "Il lago dedicato al Trout Area", address: "Via Flaminia Antica, 06023 Gualdo Tadino (PG)", map: "https://maps.app.goo.gl/uKygydaNEFUnJ5AB9" },
];

export default function LocationPage() {
  return <PublicPageLayout title="Due laghi, a Gualdo Tadino" eyebrow="Dove siamo" intro="Scegli la struttura che vuoi raggiungere e apri le indicazioni per il tuo viaggio.">
    <div className="info-grid">
      {lakes.map(lake => <article className="lake-information" key={lake.name}>
        <img src={lake.image} alt={lake.name} />
        <p className="public-page__eyebrow">{lake.description}</p>
        <h2>{lake.name}</h2>
        <address>{lake.address}</address>
        <a className="site-text-link" href="tel:+393926556115">+39 392 655 6115</a>
        <div className="lake-information__actions"><a className="site-button" href={lake.map} target="_blank" rel="noopener noreferrer">Apri indicazioni ↗</a></div>
      </article>)}
    </div>
  </PublicPageLayout>;
}
